// Deterministic UPI deep link builder — no external service, no gateway. The same algorithm is
// duplicated in mobile/packages/core/src/features/payments/upiLink.ts (separate build graphs,
// not worth a shared package for one pure function — see docs/archive/2026-08-decisions-payment-links.md).
export function buildUpiLink({ upiId, payeeName, amount, note }) {
  const params = new URLSearchParams({
    pa: upiId,
    pn: payeeName || "",
    am: Number(amount || 0).toFixed(2),
    cu: "INR",
  });
  if (note) params.set("tn", note);
  return `upi://pay?${params.toString()}`;
}
